// @ts-nocheck

import { getAppSettings } from '../utils/storage';

export async function getAuthFields() {
  const appSettings = await getAppSettings();
  return {
    deviceUUID: appSettings.boothId,
    deviceSecret: appSettings.boothSecret
  };
}
export function authenticate(deviceUUID, deviceSecret) {
  return {
    cmd: 'device/device-connect',
    deviceUUID,
    deviceSecret
  };
}

export function getQueuesStatus(boothId) {
  return {
    cmd: 'booth-queues-status',
    requestId: '1',
    boothId: boothId
  };
}

export function getComments() {
  return {
    cmd: 'booth/get-comments'
  };
}
